import PageIndex from "./page"

const App = () => {
    return (<><PageIndex /></>)
}
export default App